<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <v-card-subtitle class="pl-0" style="height: unset">{{ text }}</v-card-subtitle>
    </v-col>
    <v-col cols="6">
      <v-select
        color="primary"
        :model-value="selectedMethod"
        :items="methodOptions"
        @update:model-value="$emit('updateMethod', $event)"
        :disabled="disabledHeightMethod"
        item-title="text"
        item-value="value"
        label="Method"
        hide-details
      ></v-select>
    </v-col>
    <v-col cols="6">
      <v-select
        color="primary"
        v-model="selectRelativeValue"
        :items="relativeOptions"
        hide-details
        item-title="text"
        item-value="value"
        label="Relative value"
      ></v-select>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-text-field
        color="primary"
        :label="sectionLabel"
        class="text-field"
        :error-messages="rule"
        type="number"
        @update:model-value="$emit('updateValue', $event)"
        :model-value="modelValue[section]"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SoilProfileSection',
  props: {
    section: { type: String, default: '' },
    disabledHeightMethod: { type: Boolean, default: false },
    modelValue: { type: Object },
    selectedMethod: { type: String },
    rule: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectRelativeValue: 1 / 2,
    relativeOptions: [
      { text: '1/2', value: 1 / 2 },
      { text: '1/3', value: 1 / 3 },
      { text: '2/3', value: 2 / 3 }
    ],
    methodOptions: [
      { text: 'Distance', value: 'distance' },
      { text: 'Height', value: 'height' }
    ]
  }),
  computed: {
    text() {
      return this.section === 'x_start' ? 'Start section' : 'End section'
    },
    isEmpty() {
      return this.modelValue[this.section] === null || isNaN(this.modelValue[this.section])
    },
    limitValue() {
      return this.isEmpty ? (this.section === 'x_start' ? 'Left' : 'Right') : null
    },
    sectionLabel() {
      return this.text + (this.isEmpty ? `: ${this.limitValue}` : ' [m]')
    }
  },
  watch: {
    async selectRelativeValue() {
      await this.$emit('updateRelative', this.selectRelativeValue)
    },
    disabledHeightMethod() {
      if (this.disabledHeightMethod) {
        this.$emit('setMethod', 'distance')
      }
    }
  }
}
</script>
